import { Component } from '@mycolorway/tao';
import eventListnerMixin from 'next/javascripts/mixins/event-listener-mixin';
import pageMixin from 'next/javascripts/mixins/page-mixin';
import Dialog from 'next/javascripts/components/dialog';

import 'next/stylesheets/components/page/dialog-page';

Component('tr-dialog-page', {
  extends: [Dialog],

  mixins: [eventListnerMixin, pageMixin],

  ready() {
    if (this.opened) this.open();
  },

  setContent(content = '') {
    this.querySelector('.page__content').innerHTML = content;
  },

  disconnected() {
    if (this.mdcDialog) this.mdcDialog.destroy();
    this.stopListening();
  },
});
